// E-invoicing types for Djayma (Senegalese compliance)

export enum InvoiceStatus {
  DRAFT = "DRAFT",
  ISSUED = "ISSUED",
  PAID = "PAID",
  CANCELLED = "CANCELLED",
  REFUNDED = "REFUNDED",
}

export interface InvoiceCustomer {
  readonly name: string;
  readonly phone: string;
  readonly email?: string;
  readonly address: string;
  readonly city: string;
  readonly region: string;
}

export interface InvoiceItem {
  readonly description: string;
  readonly quantity: number;
  /** Unit price in FCFA (integer) */
  readonly unitPrice: number;
  /** Line total in FCFA (integer) */
  readonly totalPrice: number;
  /** Tax rate as decimal (e.g. 0.18) */
  readonly taxRate: number;
}

export interface Invoice {
  readonly id: string;
  /** Sequential number: FAC-YYYY-NNNNN */
  readonly number: string;
  /** ISO date string */
  readonly date: string;
  /** ISO date string */
  readonly dueDate: string;
  readonly customer: InvoiceCustomer;
  readonly items: readonly InvoiceItem[];
  /** Subtotal HT in FCFA (integer) */
  readonly subtotal: number;
  /** Tax rate as decimal (e.g. 0.18) */
  readonly taxRate: number;
  /** TVA amount in FCFA (integer) */
  readonly taxAmount: number;
  /** Total TTC in FCFA (integer) */
  readonly total: number;
  readonly currency: "XOF";
  readonly status: InvoiceStatus;
  readonly qrCode?: string;
  readonly pdfUrl?: string;
  readonly notes?: string;
}

export interface InvoiceConfig {
  readonly companyName: string;
  readonly companyAddress: string;
  readonly companyPhone: string;
  readonly companyEmail: string;
  /** NINEA fiscal identifier (placeholder until configured) */
  readonly ninea: string;
  /** Registre du Commerce number (placeholder until configured) */
  readonly rcNumber: string;
  /** Default tax rate as decimal */
  readonly defaultTaxRate: number;
  readonly invoicePrefix: string;
  readonly currency: "XOF";
}

export interface InvoiceNumberSequence {
  readonly year: number;
  readonly lastNumber: number;
  readonly prefix: string;
}

/**
 * Represents order data consumed by the invoice service.
 * Maps from the existing Order + OrderItem types.
 */
export interface OrderData {
  readonly orderId: string;
  readonly publicRef: string;
  readonly items: readonly OrderDataItem[];
  readonly subtotalHt: number;
  readonly tvaAmount: number;
  readonly deliveryFee: number;
  readonly totalTtc: number;
  readonly notes?: string;
}

export interface OrderDataItem {
  readonly description: string;
  readonly quantity: number;
  readonly unitPriceHt: number;
  readonly tvaRate: number;
}
